<template>
  <div>
    <div class="navbar nav-main w-100" style="background-color:#23409A;color:white">
      <h3 class="w-100 text-center my-3">ลงทะเบียนใช้งาน</h3>
    </div>
    <div class="w-100 session-with-nav " style="height: calc(100vh - 67px);overflow: auto;">
      <div style="text-align: right;" class="mr-2 mt-2">
        <v-btn color="#23409a" outlined icon @click="pop = true">
          <span class="fs-20 text-blue">?</span>
        </v-btn>
      </div>
      <v-dialog v-model="pop" :overlay="false" max-width="500px" transition="dialog-transition">
        <v-card class="py-2 px-5">
          <div class="text-center">
            OTP คือ รหัสที่ส่งผ่านระบบ SMS (ข้อความ) ตามเบอร์โทรศัพท์ที่แจ้งไว้
          </div>
          <div style="text-align: center;" class="mt-2">
            <v-btn color="#23409a" @click="askmore">
              <span class="text-white">สอบถามเพิ่มเติม</span>
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <div class="mb-3 flex-all-center">
        <div>
          <v-img
            class="my-5 radius-circle"
            style="width:70vw;height:auto"
            src="@/assets/rafiki.png"
          ></v-img>
        </div>
      </div>
      <div class="w-100 px-8">
        <div class="text-center">
          ระบบได้ทำการส่งรหัส OTP ไปยังเบอร์โทรศัพท์ของท่าน {{ showPhoneno }}
        </div>
        <div class="fs-14 text-gray text-center mt-2">
          <span>Ref :</span>
          <span class="mx-1" v-if="ref">{{ ref.refCode }}</span>
          <CountDownTimer
            class="mx-1"
            style="font-size: 14px"
            v-if="showCountdowntimer"
            :startmin="timeleft"
            @ontimeout="showCountdowntimer = false"
          ></CountDownTimer>
          <div class="mt-5">
            <ValidationObserver ref="observer">
              <ValidationProvider
                :rules="{
                  required: true
                }"
                name="OTP"
                v-slot="{ errors }"
              >
                <custom-input
                  :maxlength="6"
                  v-model="otp"
                  :center="true"
                  placeholder="OTP"
                  numberOnly
                  outlined
                  :error-messages="errors"
                ></custom-input>
              </ValidationProvider>
            </ValidationObserver>
          </div>
          <div style="color:black">
            <div>
              ไม่ได้รับรหัส OTP
              <span @click="sentOtp" class="text-blue" style="text-decoration: underline;"
                >ส่งใหม่อีกครั้ง</span
              >
            </div>
          </div>
        </div>
        <div class="flex-all-center mt-8 mb-5">
          <v-btn
            :loading="loading"
            @click="SubmitProcess"
            class="col-8 main-btn"
            style="color:white;"
            color="#23409a"
            >ยืนยัน</v-btn
          >
        </div>
      </div>
    </div>
    <SuccessDialog v-model="showAlert">{{ successMessage }}</SuccessDialog>
  </div>
</template>

<script>
import CountDownTimer from '@/components/CountDownTimer.vue'
import SuccessDialog from '@/components/SuccessDialog.vue'
import moment from 'moment'
import api from '@/api'
import config from '@/config'
export default {
  components: { CountDownTimer, SuccessDialog },
  data() {
    return {
      pop: false,
      otp: '',
      timeleft: 5,
      loading: false,
      checkbox: false,
      showCountdowntimer: true,
      showAlert: false,
      successMessage: ''
    }
  },
  mounted() {},
  computed: {
    userId() {
      return this.$store.state.profile.userId
    },
    idcard() {
      return this.$store.state.regisData.idcard
    },
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    },
    input() {
      return this.$store.state.regisData ? this.$store.state.regisData : null
    },
    phone() {
      return this.$store.state.changePhoneObj.phone
    },
    ref() {
      return this.$store.state.ref
    },
    showPhoneno() {
      if (this.$store.state.ref && this.$store.state.ref.phoneNumber.length === 10) {
        let phone = this.$store.state.ref.phoneNumber
        let data = [phone[0], phone[1], phone[2], '-xxx-', phone[6], phone[7], phone[8], phone[9]]
        return data.join('')
      } else {
        return this.$store.state.ref.phoneNumber ? this.$store.state.ref.phoneNumber : ''
      }
    },
    paraUserId() {
      return this.$store.state.query.userid
    },
    assigngroupid() {
      return this.$store.state.query.assigngroupid ? this.$store.state.query.assigngroupid : 0
    },
    authData() {
      return this.$store.state.formatAuthorizeData
    }
  },
  methods: {
    async sentOtp() {
      let type = this.$store.state.changePhoneMethod
      let data = null
      let res = null
      if (type == 'sync') {
        data = {
          LineUserId: this.userId,
          PhoneNumber: this.phone,
          pageid: config.pageid
        }
        this.loading = true
        this.showCountdowntimer = false
        res = await api.regisedSendOtp(data)
        this.showCountdowntimer = true
      } else {
        // authorize
        data = {
          idCard: this.authData.idcard,
          dob: this.authData.dob,
          nextCardId: this.authData.nextcard,
          phoneNumber: this.phone,
          pageid: config.pageid
        }
        this.loading = true
        this.showCountdowntimer = false
        res = await api.SendOtpWithAuth(data)
        this.showCountdowntimer = true
      }

      this.loading = false
      if (res.responsecode == 200) {
        this.$store.state.ref = res.data
      } else if (res.responsecode == 300) {
        this.$swal.fire({
          type: 'error',
          text: 'ไม่มีข้อมูลในระบบ'
        })
      }
    },
    async askmore() {
      await this.$store.dispatch('sendMessage', 'สอบถามเพิ่มเติมเรื่อง OTP')
      this.$liff.closeWindow()
    },
    async SubmitProcess() {
      let valid = this.$refs.observer.validate()
      if (valid) {
        // Check OTP first and then post api to update phone number
        this.loading = true
        let OTPValid = await this.CheckOTP()
        if (OTPValid) {
          // Seperate 2 case
          let type = this.$store.state.changePhoneMethod
          if (type == 'sync') {
            // Already sync via line
            // Update phone number via API
            let data = {
              pageid: config.pageid,
              phone: this.phone,
              userId: this.$store.state.profile.userId
            }
            let result = await api.UpdatePhone(data)
            if (result && result.responsecode == 200 && result.status) {
              // Alert to client and then close liff
              this.showAlert = true
              this.successMessage = 'ระบบได้ทำการแก้ไขเบอร์โทรศัพท์ให้ท่านเรียบร้อยแล้ว'
            } else {
              this.$swal.fire({ type: 'error', text: 'อัพเดทข้อมูลไม่สำเร็จ' })
            }
          } else {
            // Pass authorize then create ticket set pending status
            let userId = this.userId || this.paraUserId
            let channel = userId.length > 25 ? 'line' : 'facebook'
            if (channel == 'line' && !userId.match(`__${config.pageid}`)) {
              userId = `${userId}__${config.pageid}`
            }
            let body = {
              pageid: config.pageid,
              userid: userId,
              subject: 'ต้องการเปลี่ยนแปลงเบอร์โทรศัพท์',
              details: 'ไม่ผูกบัญชี',
              channel,
              status: 'pending',
              assigngroupid: this.assigngroupid,
              json_variable: {
                type: 'phone',
                userdata: {
                  dob: this.authData.dob,
                  nextCard: this.authData.nextcard,
                  IDCard: this.authData.idcard,
                  faceImage: this.authData.faceImage,
                  idcardImage: this.authData.idcardImage
                },
                updateData: this.phone
              }
            }
            let createStatus = await api.createTicket(body)
            if (createStatus) {
              this.successMessage = 'กรอกข้อมูลสำเร็จ'
              this.showAlert = true
              await this.$store.dispatch('sendMessage', 'กรุณารอเจ้าหน้าที่ทำการตรวจสอบข้อมูล')
            } else {
              this.$swal.fire({ type: 'error', text: 'อัพเดทข้อมูลไม่สำเร็จ' })
            }
          }
        }
        this.loading = false
      }
    },
    async CheckOTP() {
      let status = false
      let body = {
        userId: this.$store.state.profile.userId,
        refOTP: this.otp,
        phoneNumber: this.phone,
        pageid: config.pageid
      }
      let res = await api.checkOtp(body)
      if (res.responsecode == 200) {
        if (res.data.message == 'match') {
          // go on
          this.$store.state.checkOtp = true
          status = true
        } else {
          this.$swal.fire({
            type: 'error',
            text: 'OTP หมดอายุ กรุณากด ส่งรหัสใหม่ อีกครั้ง'
          })
        }
        // this.$emit("next");
      } else if (res.responsecode == 300) {
        this.$swal.fire({
          type: 'error',
          text: 'OTP หมดอายุ กรุณากด ส่งรหัสใหม่ อีกครั้ง'
        })
      }
      return status
    }
  }
}
</script>

<style>
.v-tooltip__content {
  background-color: #fafafa !important;
  color: black !important;
  max-width: 80%;
  border: 1px solid #ebebeb !important;
  box-sizing: border-box !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
  border-radius: 10px !important;
}
.v-application .primary--text {
  color: #23409a !important;
  caret-color: #23409a !important;
}
.slidedealer,
.slidedealer-back {
  &-enter-active,
  &-leave-active {
    position: absolute;
    width: 100%;
    background: white;
    min-height: 100vh;
    top: 12px;
  }
}
// router view
.slidedealer-enter-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(100%);
}
.slidedealer-enter-to {
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-leave-active {
  z-index: -1;
}
.slidedealer-leave-to {
  z-index: -1;
}
// router view back

.slidedealer-back-enter-active {
  z-index: -1;
}
.slidedealer-back-enter-to {
  z-index: -1;
}

.slidedealer-back-leave-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-back-leave-to {
  transform: translateX(100%);
  z-index: 2;
}
.addcartbtn {
  position: fixed;
  text-align: center;
  padding-top: 15px;
  z-index: 1;
  font-size: 23px;
  bottom: 0px;
  background-color: rgb(12, 77, 157);
  width: 90vw;
  height: 60px;
  color: white;
  border-radius: 13px 13px 0px 0px;
  left: 50%;
  transform: translate(-50%, 0);
}
.myshadow {
  -webkit-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.95);
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
